import { Injectable } from '@angular/core';
import { AccessoryCharge } from '@cargos/sprintpay-models';
import { Observable, map } from 'rxjs';
import { AccessoriesService } from 'src/app/shared/services/accessories/accessories.service';

@Injectable({
    providedIn: 'root',
})
export class AccessoriesUtilsService {
    constructor(private accessoriesService: AccessoriesService) {}

    getAccessoryRateByPaymentType(paymentType: string): Observable<number | null> {
        return this.accessoriesService.getAccessories$().pipe(
            map((accessories: AccessoryCharge[]) => {
                const accesory = accessories.find((accessory) => accessory.paymentType === paymentType);

                return accesory ? (accesory.isFreeForm ? null : accesory.rate || null) : null;
            })
        );
    }
}
